import { Injectable } from '@angular/core';
import { Observable, of, Observer } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { catchError } from 'rxjs/operators';
import { ConstantsModule } from 'src/app/common/constants/constants.module';
import { HttperrorhandlerService } from 'src/app/common/http/httperrorhandler.service';
import { UtilsModule } from 'src/app/common/utils/utils.module';
import {NgbModal, NgbActiveModal} from "@ng-bootstrap/ng-bootstrap";
import { Router } from '@angular/router';
import {LogoutPopupComponent} from 'src/app/components/logout-popup/logout-popup.component'
import { AuthloginService } from '../login/authlogin.service';
import {  CookieService  } from 'ngx-cookie-service'; 
import { ToastrService } from 'ngx-toastr';
import { DatePipe } from '@angular/common'



@Injectable({
  providedIn: 'root'
})
export class SubmitdataService {
  activespineer: boolean;
  userdetails : any;
  activeModal: boolean = false;
  currentYear: any;
  assesmentyears: any;
  yearsPayload: { aY: any; cUUID: string; pUUID: string; component: number; cType: string; subTp: string; yc: number; };
  yearDropDownList: any;
  
  constructor(private http: HttpClient,
    private constants: ConstantsModule,
    private errorHandler: HttperrorhandlerService,
    private utils: UtilsModule,
    private modalService : NgbModal,private router: Router,
    private sessionlogin : AuthloginService,
    private cookie : CookieService,
    private toastr : ToastrService,
    private datepipe : DatePipe) { }
  // getassesmentYear(): any{
  //   let api = "getassesmentYear";
  //   return [
  //     // '2015-2016','2016-2017','2017-2018','2018-2019', '2019-2020','2020-2021',
  //         '2021-2022','2022-2023'
  //         // ,'2023-2024'
  //       ];
  //   // return this.http.get<any>(this.constants.API_URL + api).pipe(
  //   //   catchError(this.errorHandler.handleError('excelupload', []))
  //   // );
  // }
 TIME_PERIOD_LIST={
   "monthly":  "Monthly",
   "quarterly":"Quarterly",
   "halfyearly" : "Half Yearly",
   "annually" : "Annually",
   }
   QUATERLY_LIST={
     "q1":"Q1 (Apr - Jun)",
     "q2":"Q2 (Jul - Sep)",
     "q3":"Q3 (Oct - Dec)",
     "q4":"Q4 (Jan - Mar)"
   }
   HALFYEARLY_LIST= {
     "h1": "Half Year 1(April-September)",
     "h2": "Half Year 2(October-March)",
   }
 
  getMonthList(){
    return ["04","05","06","07","08","09","10","11","12","01","02","03"];
  }
  getassesmentYearForMIs(): any{
    let api = "getassesmentYear";
    return [
      // '2015-2016','2016-2017','2017-2018','2018-2019', '2019-2020',
      '2020-2021',
      '2021-2022','2022-2023','2023-2024'];
    // return this.http.get<any>(this.constants.API_URL + api).pipe(
    //   catchError(this.errorHandler.handleError('excelupload', []))
    // );
  }
  getAssesmentYearDistrict() :any{
    let api = "getassesmentYear"
    return [ 
      // '2019-2020','2020-2021',
      '2021-2022','2022-2023','2023-2024'];
  }
  SECTOR_LIST={
    "tannery":  "TANNERY",
    "textile":"TEXTILE",
     "paper" :  "PAPER",
     "metal":"METAL",
     "oil" : "OIL",
     "food" : "FOOD",
     "others" : "OTHERS"
   }
   LANGUAGE_LIST = {
     "hindi": "HINDI",
     "english" : "ENGLISH"
   }
  getPrevYear(year){
    let obj = {
      "2015-2016" : "2014-2015",
      "2016-2017" : "2015-2016",
      "2017-2018" : "2016-2017",
      "2018-2019" : "2017-2018",
      "2019-2020" : "2018-2019",
      "2020-2021" : "2019-2020"
    }
    return obj[year];
  }

  getdynamicYears(){
    let date = new Date();
    let currentYear = date.getFullYear();
    let currentmonth = date.getMonth();
    let dropDownYear;
    if(currentmonth <3){
      dropDownYear = (currentYear - 1) + '-'+ currentYear;
    } else{
      dropDownYear = currentYear + '-'+ (currentYear + 1);
    } 
    this.currentYear = dropDownYear;

    this.yearsPayload = {
      "aY": this.currentYear,
      "cUUID": "f78f615d-e270-4f93-90ac-27608e756b85",
      "pUUID": "ffce954d-24e1-494b-ba7e-0931d8ad6085",
      "component":1,
      "cType":"DISTRICT",
      "subTp":"00",
      "yc":0
    }
    // this.currentYearVar = currentYear;
  }

  checkwindow(data,fieldvalue,lu,request?:boolean){
    let flag = false;
    if(data[fieldvalue] && !data[fieldvalue][lu].hasOwnProperty('status')){
      console.log(data[fieldvalue][lu].hasOwnProperty('status'))
      if(data[fieldvalue][lu]['sdate'] && data[fieldvalue][lu]['edate']){
        if(request){
          if((data[fieldvalue][lu]['sdate'] <= this.datepipe.transform(new Date(), 'yyyyMMdd') && this.datepipe.transform(new Date(), 'yyyyMMdd') <= data[fieldvalue][lu]['edate'])){
          flag = true;
          this.toastr.success("The time window has not expired");
          }
        else {
          // console.log("sdflhsd")
         flag = false;
        }
        } else {
        if((data[fieldvalue][lu]['sdate'] <= this.datepipe.transform(new Date(), 'yyyyMMdd') && this.datepipe.transform(new Date(), 'yyyyMMdd') <= data[fieldvalue][lu]['edate']))
          flag = false;
        else {
          // console.log("sdflhsd")
         this.toastr.error("The time window for submitting data has expired. Please contact Niti-ayog for extension.");
         flag = true;
        }
      }
      } else {
        flag = false
      }
    } else if(!data['status']){
      // console.log("jeirsdfsdfk",data[fieldvalue][lu],data,fieldvalue)
      this.toastr.error(data[fieldvalue][lu]['msg'])
      flag = true;
    }
    else {
      flag = false;
    }
    return flag;
  }
  getlanguageData():Observable<any>{
    const requestOptions: Object = {
      responseType: 'blob'
    }
    let excelDownload_api = "nmcg/commities" + '/' + "english";
    return this.http.get<Blob>(this.constants.API_URL + excelDownload_api,requestOptions).pipe(
      catchError(this.errorHandler.handleError('excelDownload', []))
    );
  }
  getlanguagehindiFile():Observable<any>{
    const requestOptions: Object = {
      responseType: 'blob'
    }
    let excelDownload_api = "nmcg/commities" + '/' + "hindi";
    return this.http.get<Blob>(this.constants.API_URL + excelDownload_api,requestOptions).pipe(
      catchError(this.errorHandler.handleError('excelDownload', []))
    );
  }
  changeMoMDocument(options: object):Observable<any>{
    return this.http.post<any>(this.constants.API_URL + "changeMomDocument", options).pipe(
      catchError(this.errorHandler.handleError('changeMoMDocument : ', [])))
  }
  getAssesmentData(options): Promise<any>{
    let flag : boolean;
    flag = false
    // console.log("jerere")
    let promise = new Promise((resolve, reject) => {
      this.getDataForAssesment(options).subscribe(data =>{
          this.activespineer = false;
          // flag = true;
          // console.log("hmmmm")
            if(data && data['hierarchy']){
              if(Object.keys(data['hierarchy']).length > 0){
                if(data['hierarchy']['ADMIN']){
                  if(data['hierarchy']['ADMIN'].length > 0){
                    if(data['hierarchy']['ADMIN'].includes("DISTRICT")){
                      flag = true;
                    }
                  }
                }
              } 
            }
            resolve(flag);
    }, err => {
      console.log("Error Occurred", err);
      reject(flag)
    });
  });
  // console.log(promise,"asasasasa")
  return promise;
  }
  getWindowStatus(options){
    let flag : boolean;
    flag = false
    // console.log("jerere")
    let promise = new Promise((resolve, reject) => {
      this.getWindowStatusData(options).subscribe(data =>{
          this.activespineer = false;
          if(data){
          //   let data = {
          //     "2018-2019": {
          //       "sdate": 20170801,
          //       "edate": 20190811
          //     },
          //     "2017-2018": {
          //         "sdate": 20170801,
          //         "edate": 20201120
          //     }
          // }
            resolve(data);
          } else
            resolve(false);
    }, err => {
      console.log("Error Occurred", err);
      reject(flag)
    });
  });
  // console.log(promise,"asasasasa")
  return promise;
  }
  getWindowStatusDatas(options: object):Observable<any>{
    return this.http.post<any>(this.constants.API_URL + "cwmi/window/multiyearwindow", options).pipe(
      catchError(this.errorHandler.handleError('excelupload', [])) );
  }
  getStatusOfToken(){
    this.userdetails = this.sessionlogin.checkloginstatus();
    let option = this.userdetails ? this.userdetails['expirationTime'] : null;
    this.getStatus(option); 
  }
  getStatus(option){
    let d = new Date();
    let n = d.getTime();
    if(!this.activeModal){
      if(option < n){
        this.activeModal = true;
        let modalRef = this.modalService.open(LogoutPopupComponent,{ backdrop: 'static',windowClass: 'backgroundTransparent  my-class'});
        modalRef.componentInstance.title = 'Session Expired';
        modalRef.componentInstance.onLogout.subscribe((receivedEntry) => {
        if(receivedEntry === true){
          this.activespineer = true;
          let url  = this.router.url; 
          // this.sessionlogin.logoutuser().subscribe(logoutres =>{
            this.activespineer = false;
            this.activeModal = false;
            // if(logoutres['result']['success']){
              this.sessionlogin.clearsession();
              this.sessionlogin.clearusersession();
              if(url.search('submitdata') != -1){
                this.router.navigate(["/gis"]);
                setTimeout(() => { location.reload(); }, 10);
              }else{
                setTimeout(() => { location.reload(); }, 10);
              }
            // } else {
            //   this.toastr.error(logoutres['result']['message'])
            // }
          
          // })
        }
      })
      }else{
      }
    }
  }
  sortStates(property) {
    var sortOrder = 1;

    if(property[0] === "-") {
        sortOrder = -1;
        property = property.substr(1);
    }

    return function (a,b) {
        if(sortOrder == -1){
            return b[property].localeCompare(a[property]);
        }else{
            return a[property].localeCompare(b[property]);
        }        
    }
}
  getWritableObject(obj: object): object {
    if (obj == null || obj == undefined) return obj;

    let objectConfig = {};
    for (let key in obj) {
      objectConfig[key] = obj[key];
    }

    return objectConfig;
  }
  getLocationList(options: object):Observable<any>{
    let api = "locations/allChildrenForParentChildType";
    // if(options['type'] == 'state'){
    //   return [{"uuid":'609c5df4-6414-4bbd-a22d-ff5fbdad6836','name':'Andra Pradesh'},{"uuid":'12121','name':'absc'},{"uuid":'12121','name':'absc'}]
    // }else{
    //   return [{"uuid":'f99faae7-24c5-485f-a471-bc9afe353f4b','name':'Guntur'},{"uuid":'12121','name':'absc'},{"uuid":'12121','name':'absc'}]
    // }
    return this.http.post<any>(this.constants.API_URL + api, options,this.sessionlogin.getHeadersWithCsrf()).pipe(
      catchError(this.errorHandler.handleError('excelupload', []))
    );
    // return {"NORTH EASTERN AND HIMALAYAN":[{"name":"JAMMU AND KASHMIR","uuid":"12f0823e-2c16-4765-8137-585b3d5123ac"},{"name":"NAGALAND","uuid":"37572702-1c31-4723-8328-0a1757f6b4e1"},{"name":"MANIPUR","uuid":"0ee3cc5b-1b67-465c-9528-46540aea9cb7"},{"name":"PUDUCHERRY","uuid":"fd163bec-156c-4633-a7b7-5dfee5fcdf57"},{"name":"SIKKIM","uuid":"19903c2c-ed18-4782-a679-dc10e8aa71ed"},{"name":"HIMACHAL PRADESH","uuid":"b8c2ccc0-b638-468a-84e7-3512ece9b3a5"},{"name":"TRIPURA","uuid":"40320284-8d82-4f7e-80d7-00a00bb0e5b0"},{"name":"ANDAMAN AND NICOBAR","uuid":"68dad067-a4cc-4397-a6fd-fc10ef7cc933"},{"name":"MEGHALAYA","uuid":"b967d23e-68c8-492c-a372-9623441f7d24"},{"name":"ARUNACHAL PRADESH","uuid":"f318279f-537d-4373-b9dc-ac347cdef82f"},{"name":"ASSAM","uuid":"94360caf-ebf0-4303-8c9e-3509bb0cded2"},{"name":"MIZORAM","uuid":"812072c8-d651-485c-88e8-7dd29d8c183b"},{"name":"UTTARAKHAND","uuid":"200030a1-6d27-4dff-988a-e2104ff62ab8"}],"NON HIMALAYAN":[{"name":"CHANDIGARH","uuid":"d6da1adf-2a9c-4908-a356-e7668d4ab108"},{"name":"TELANGANA","uuid":"a1588b13-5700-450d-b51d-b782ed565801"},{"name":"TAMILNADU","uuid":"e98cd5b7-6556-4c0f-a778-3429e1c14a6b"},{"name":"BIHAR","uuid":"ae12d8f1-e36c-445f-8d32-80f958766b4e"},{"name":"GOA","uuid":"7f615d2f-0be6-42bf-891f-7239e101e487"},{"name":"HARYANA","uuid":"648a95f6-9249-4c92-8ae4-a9d93eb7c898"},{"name":"MAHARASHTRA","uuid":"e7b3f02d-2497-4bcd-9e20-baa4b621822b"},{"name":"KARNATAKA","uuid":"eaec6bbb-a219-415f-bdba-991c42586352"},{"name":"MADHYA PRADESH","uuid":"f38e6de8-396e-47b4-af18-32c333eddccc"},{"name":"JHARKHAND","uuid":"496bae22-c752-43d6-9bda-7798f9d3b32f"},{"name":"CHHATTISGARH","uuid":"bd81d570-0e97-4dad-9bcd-219a05f56f2f"},{"name":"GUJRAT","uuid":"8fd29251-6e20-4f33-9a96-f47cab45eb13"},{"name":"WEST BENGAL","uuid":"68ecabb4-0ea5-4909-b8e3-20bbaa7b91e8"},{"name":"ODISHA","uuid":"d19a5290-2e40-494a-83d2-98f4c845b1f1"},{"name":"DADRA AND NAGAR HAVELI","uuid":"f5c761d1-d9c5-4e5f-af48-2cdfc1c92ce8"},{"name":"DELHI","uuid":"a1ac5d18-8c9a-4047-8fdd-4d7d9deaa34e"},{"name":"LAKSHDWEEP","uuid":"5f2a2b2b-cd02-4a00-94ec-3fc97d9f0d19"},{"name":"UTTAR PRADESH","uuid":"edce8ca7-bf15-4b5e-b4c5-b10c543acd83"},{"name":"DAMAN AND DIU","uuid":"ee1789e0-3831-4cdb-b0b8-77231309cd7e"},{"name":"KERALA","uuid":"ca25704a-43d0-42ad-bcf4-b2b60270594c"},{"name":"ANDHRA PRADESH","uuid":"609c5df4-6414-4bbd-a22d-ff5fbdad6836"},{"name":"PUNJAB","uuid":"5ff5533e-36c5-4c24-abff-1cbbea6f2bdf"},{"name":"RAJASTHAN","uuid":"785cc6f0-e9d0-4961-9578-08ed2f24377a"}]}
  }
  // getCatagorylist(option: object):Observable<any>{
  //   return this.http.post<any>(this.constants.API_URL + "cwmi/gis/entitycategorization", option).pipe(
  //     catchError(this.errorHandler.handleError('get parent child list : ', [])))
  // }
  getDiffFileType(options: object): any{
    console.log("mm",this.getDiffFileType)
    let api = "getlocationlist";
    return [{key:'Cropwater',value:'Cropwater'},{key:'Groundwater',value:'Groundwater'},{key:'Rainfall',value:'Rainfall'},{key:'Recharge',value:'Recharge'},{key:'Draft',value:'Draft'},{key:'BasicData',value:'BasicData'},{key:'OtherResources',value:'Other Resources'},{key:'Flux',value:'Resultant Flows'},{key:'QualityTagging',value:'Quality Tagging'}]
    // return this.http.post<any>(this.constants.API_URL + api, options).pipe(
    //   catchError(this.errorHandler.handleError('excelupload', []))
    // );
  }
  // getassesmentUnitsForState(options):Observable <any>{
  //   let api = "cwmi/stateHieAndAssmntData";

  //   return this.http.post<any>(this.constants.API_URL + api,options).pipe(
  //     catchError(this.errorHandler.handleError('get assesment unit', []))
  //   );
  // }
  downloadExcelData(params : object):Observable<any>{
    let excelDownload_api = 'nmcg/download/file/indicordata';
    return this.http.post<Blob>(this.constants.API_URL + excelDownload_api, params, {responseType: 'blob' as 'json'}).pipe(
      catchError(this.errorHandler.handleError('excelDownload', []))
    );
  }
  userStatus(option: object):Observable<any>{
    return this.http.post<any>(this.constants.API_URL + "cwmi/userstatistics", option).pipe(
      catchError(this.errorHandler.handleError('get parent child list : ', [])))
  }
  downloadExcelDatas(params : object):Observable<any>{
    let excelDownload_api = 'cwmi/file/fetch';
    return this.http.post<Blob>(this.constants.API_URL + excelDownload_api, params, {responseType: 'blob' as 'json'}).pipe(
      catchError(this.errorHandler.handleError('excelDownload', []))
    );
  }
  uploadexcelFile(options: object): Observable<any>{
    this.getStatusOfToken();
    let headers = this.sessionlogin.getHeadersWithCsrf();
    let excelupload = "cwmi/upload/file/indicatordata";
    //let parms = {"params":options}
    var fd = new FormData();
        // fd.append('file',file);
        // fd.append('params',JSON.stringify(options))
       let tempobj = Object.keys(options);
       tempobj.forEach(key => {
          fd.append(key,options[key]);
         
       }); 
    return this.http.post<any>(this.constants.API_URL + excelupload, fd,
      { headers: {'X-CSRF-TOKEN' : headers['headers']['X-CSRF-TOKEN']},withCredentials:true}).pipe(
      catchError(this.errorHandler.handleError('excelupload', []))
    );
  }
  fileformatupload(postdata :object):Observable<any>{
    this.getStatusOfToken();
    let headers = this.sessionlogin.getHeadersWithCsrf();
    let excelupload = "nmcg/upload/file/indicatordata";
    //let parms = {"params":options}
    var fd = new FormData();
        // fd.append('file',file);
        // fd.append('params',JSON.stringify(options))
       let tempobj = Object.keys(postdata);
       tempobj.forEach(key => {
          fd.append(key,postdata[key]);
         
       }); 
    return this.http.post<any>(this.constants.API_URL + excelupload, fd,
      { headers: {'X-CSRF-TOKEN' : headers['headers']['X-CSRF-TOKEN']},withCredentials:true}).pipe(
      catchError(this.errorHandler.handleError('excelupload', []))
    );
  }

  getcolourThemeData(option: object):Observable<any>{
    return this.http.post<any>(this.constants.API_URL + "cwmi/fetch/theme/colorcode", option).pipe(
      catchError(this.errorHandler.handleError('get parent child list : ', [])));
      
  }

  // getcolourThemeData(option: object):Observable<any>{
  //   return this.http.post<any>(this.constants.API_URL + "cwmi/fetch/theme/colorcode", option).pipe(
  //     catchError(this.errorHandler.handleError('get parent child list : ', [])));
      
  // }

  notifyareafileupload(options: object): Observable<any>{
    let notifyarea = "gec/notifyarea";
      var fd = new FormData();

       let tempobj = Object.keys(options);
       tempobj.forEach(key => {
          fd.append(key,options[key]);
         
       }); 
    return this.http.post<any>(this.constants.API_URL + notifyarea, fd).pipe(
      catchError(this.errorHandler.handleError('notifyarea', []))
    );
  }
  shapefileupload(options: object): Observable<any>{
    let aquifire = "py/shpAutomation/shpValidate";
      var fd = new FormData();

       let tempobj = Object.keys(options);
       tempobj.forEach(key => {
          fd.append(key,options[key]);
         
       }); 
       console.log("herere",fd);
       
      //  var finalpostdata = {
      //    "stateName" : options['stateName'],
      //    "zipFile" : fd
      //  }
       console.log(fd);
       
    return this.http.post<any>(this.constants.API_URL_SHAPEFILE + aquifire, fd).pipe(
      catchError(this.errorHandler.handleError('aquifire', []))
    );
  }
  getIndicatorsHeirarchy(options: object):Observable<any> {
    this.userdetails = this.sessionlogin.checkloginstatus();
    if(!options['type'] && this.userdetails){
      options['type'] = this.userdetails['loggedUserData']['userProfile']['locationType']
    }
    let api = "cwmi/fetchindicatordata/"+options['ay']+'/'+options['type'];
    return this.http.get<any>(this.constants.API_URL + api).pipe(
        catchError(this.errorHandler.handleError('excelupload', []))
      );
  }
  getIndicatorsBusData(option: object):Observable<any>{
    return this.http.post<any>(this.constants.API_URL + "nmcg/getIndicatorData", option).pipe(
      catchError(this.errorHandler.handleError('get parent child list : ', [])))
  }
  downloadExcel(params : object):Observable<any>{
    let excelDownload_api = 'nmcg/file/fetch';
    return this.http.post<Blob>(this.constants.API_URL + excelDownload_api, params, {responseType: 'blob' as 'json'}).pipe(
      catchError(this.errorHandler.handleError('excelDownload', []))
    );
  }
  getIndicatorsHeirarchys(options: object):Observable<any> {
    this.userdetails = this.sessionlogin.checkloginstatus();
    let api = "cwmi/fetchindicatordata/"+options['ay']+"/"+"STATE";
    return this.http.get<any>(this.constants.API_URL + api).pipe(
        catchError(this.errorHandler.handleError('excelupload', []))
      );
  }
  fetchuploadData(options: object):Observable<any>{
    return this.http.post<any>(this.constants.API_URL + "nmcg/uploadConsolidatedMeetingReport", options).pipe(
      catchError(this.errorHandler.handleError('get parent child list : ', [])))
  }
  fetchConsolidatedMeetingReport(options: object):Observable<any>{
    return this.http.post<any>(this.constants.API_URL + "nmcg/fetchConsolidatedMeetingReport", options).pipe(
      catchError(this.errorHandler.handleError('get parent child list : ', [])))
  }
  fetchdataForWeights(options :Object):Observable<any>{
    return this.http.post<any>(this.constants.API_URL + "nmcg/fetchweightData", options).pipe(
      catchError(this.errorHandler.handleError('get parent child list : ', [])))
  }
  getmeetingDelayedData(options :Object):Observable<any>{
    return this.http.post<any>(this.constants.API_URL + "nmcg/meetingDelayed", options).pipe(
      catchError(this.errorHandler.handleError('get parent child list : ', [])))
  }
  fetchUploadedFileDetails(options :Object):Observable<any>{
    return this.http.post<any>(this.constants.API_URL + "nmcg/fetchUploadedFileDetails", options).pipe(
      catchError(this.errorHandler.handleError('get parent child list : ', [])))
  }
  FetchIndicators(options: object):Observable<any> {
    this.userdetails = this.sessionlogin.checkloginstatus();
    let api = "nmcg/fetchindicatordata/"+options['ay']+"/"+"DISTRICT";
    return this.http.get<any>(this.constants.API_URL + api).pipe(
        catchError(this.errorHandler.handleError('excelupload', []))
      );
  }
  getIndicatorsHeirarchyy(options: object):Observable<any> {
    this.userdetails = this.sessionlogin.checkloginstatus();
    let api = "cwmi/fetchindicatordata/"+options['ay']+"/"+"DISTRICT";
    return this.http.get<any>(this.constants.API_URL + api).pipe(
        catchError(this.errorHandler.handleError('excelupload', []))
      );
  }
  getValidateReports(option: object):Observable<any>{
    return this.http.post<any>(this.constants.API_URL + "nmcg/getValidateReports", option,this.sessionlogin.getHeadersWithCsrf()).pipe(
      catchError(this.errorHandler.handleError('get parent child list : ', [])))
  }
  gethistorydata(option: object):Observable<any>{
    return this.http.post<any>(this.constants.API_URL + "nmcg/getActivityLog", option).pipe(
      catchError(this.errorHandler.handleError('get parent child list : ', [])))
  }
  submitindicatorsdata(option: object):Observable<any>{
    this.getStatusOfToken();
    return this.http.post<any>(this.constants.API_URL + "nmcg/upload/form/indicatordata", option,this.sessionlogin.getHeadersWithCsrf()).pipe(
      catchError(this.errorHandler.handleError('get parent child list : ', [])))
  }
  submitmeetingdata(option: object):Observable<any>{
    this.getStatusOfToken();
    return this.http.post<any>(this.constants.API_URL + "nmcg/upload/uploadMeeting", option,this.sessionlogin.getHeadersWithCsrf()).pipe(
      catchError(this.errorHandler.handleError('get parent child list : ', [])))
  }
  getrawdata(option: object):Observable<any>{
    this.getStatusOfToken();
    return this.http.post<any>(this.constants.API_URL + "nmcg/getRawDataReport", option,this.sessionlogin.getHeadersWithCsrf()).pipe(
      catchError(this.errorHandler.handleError('get parent child list : ', [])))
  }
  getfetchmeetingDetails(option: object):Observable<any>{
    this.getStatusOfToken();
    return this.http.post<any>(this.constants.API_URL + "nmcg/fetchMeetingAttendanceDetails", option,this.sessionlogin.getHeadersWithCsrf()).pipe(
      catchError(this.errorHandler.handleError('get parent child list : ', [])))
  }
  getDistReportData(option: object):Observable<any>{
    this.getStatusOfToken();
    return this.http.post<any>(this.constants.API_URL + "nmcg/getAvailableDistReportData", option,this.sessionlogin.getHeadersWithCsrf()).pipe(
      catchError(this.errorHandler.handleError('get parent child list : ', [])))
  }
  downloadrawData(option: object):Observable<any>{
    const requestOptions: Object = {
      responseType: 'blob'
    }
    return this.http.post<any>(this.constants.API_URL + "nmcg/downloadRawDataReport", option,requestOptions).pipe(
    catchError(this.errorHandler.handleError('get parent child list : ', [])))
    }
  downloadReportSummary(option: object):Observable<any>{
      const requestOptions: Object = {
        responseType: 'blob'
      }
      return this.http.post<any>(this.constants.API_URL + "nmcg/getAvailableDistReportDataStates", option,requestOptions).pipe(
      catchError(this.errorHandler.handleError('get parent child list : ', [])))
  }
  submituploadData(option: object):Observable<any>{
    this.getStatusOfToken();
    return this.http.post<any>(this.constants.API_URL + "nmcg/upload/form/indicatordata", option,this.sessionlogin.getHeadersWithCsrf()).pipe(
      catchError(this.errorHandler.handleError('get parent child list : ', [])))
  }
  downloadIndicatorTableData(option: object):Observable<any>{
    return this.http.post<any>(this.constants.API_URL + "cwmi/indicatorstatusreport", option, {responseType: 'blob' as 'json'}).pipe(
    catchError(this.errorHandler.handleError('get parent child list : ', [])))
    }
  approveorreject(option: object):Observable<any>{
    this.getStatusOfToken();
    return this.http.post<any>(this.constants.API_URL + "nmcg/upload/approveOrReject", option,this.sessionlogin.getHeadersWithCsrf()).pipe(
      catchError(this.errorHandler.handleError('get parent child list : ', [])))
  }
  modifyData(option: object):Observable<any>{
    this.getStatusOfToken();
    return this.http.post<any>(this.constants.API_URL + "nmcg/modifyData", option,this.sessionlogin.getHeadersWithCsrf()).pipe(
      catchError(this.errorHandler.handleError('get parent child list : ', [])))
  }
  getPieChartData(option: object):Observable<any>{
    return this.http.post<any>(this.constants.API_URL + "cwmi/userstats", option).pipe(
      catchError(this.errorHandler.handleError('get parent child list : ', [])))
  }
  getBarChartData(option: object):Observable<any>{
    return this.http.post<any>(this.constants.API_URL + "nmcg/entityscore", option).pipe(
      catchError(this.errorHandler.handleError('get parent child list : ', [])))
  }
  getBarBubbleChartData(option: object):Observable<any>{
    return this.http.post<any>(this.constants.API_URL + "nmcg/locationComparison", option).pipe(
      catchError(this.errorHandler.handleError('get parent child list : ', [])))
  }
  getBubbleChartData(option: object):Observable<any>{
    return this.http.post<any>(this.constants.API_URL + "nmcg/computeperformance ", option).pipe(
      catchError(this.errorHandler.handleError('get parent child list : ', [])))
  }
  getComparisonReportTableData(option: object):Observable<any>{
    return this.http.post<any>(this.constants.API_URL + "nmcg/comparisonreport", option).pipe(
      catchError(this.errorHandler.handleError('get parent child list : ', [])))
  }
  downloadComparisonTableData(option: object):Observable<any>{
    // return this.http.post<any>(this.constants.API_URL + "cwmi/comparisonreport", option, {responseType: 'blob' as 'json'}).pipe(
      // catchError(this.errorHandler.handleError('get parent child list : ', [])))
    return this.http.post<any>(this.constants.API_URL + "nmcg/comparisonreport", option, {responseType: 'blob' as 'json'}).pipe(
      catchError(this.errorHandler.handleError('get parent child list : ', [])))
  }
  getCustomRankingData(option: object):Observable<any>{
    return this.http.post<any>(this.constants.API_URL + "nmcg/getCustomRank", option).pipe(
      catchError(this.errorHandler.handleError('get parent child list : ', [])))
  }
  getthemeweight(option: object):Observable<any>{
    return this.http.post<any>(this.constants.API_URL + "cwmi/indicatorwithweight", option).pipe(
      catchError(this.errorHandler.handleError('get parent child list : ', [])))
  }
  addIndicatorfilter(option: object):Observable<any>{
    return this.http.post<any>(this.constants.API_URL + "nmcg/addindicatorfilter", option).pipe(
      catchError(this.errorHandler.handleError('get parent child list : ', [])))
  }
  uploadFile(options: object): Observable<any>{
    let excelupload = "nmcg/fileuploadnew";
    //let parms = {"params":options}
    var fd = new FormData();
        // fd.append('file',file);
        // fd.append('params',JSON.stringify(options))
       let tempobj = Object.keys(options);
       tempobj.forEach(key => {
          fd.append(key,options[key]);
         
       }); 
    return this.http.post<any>(this.constants.API_URL + excelupload, fd).pipe(
      catchError(this.errorHandler.handleError('excelupload', []))
    );
  }
  addtheme(option: object):Observable<any>{
    this.getStatusOfToken();
    return this.http.post<any>(this.constants.API_URL + "cwmi/addindicatorortheme", option,this.sessionlogin.getHeadersWithCsrf()).pipe(
      catchError(this.errorHandler.handleError('get parent child list : ', [])))
  }
  addthemesForNmcg(option: object):Observable<any>{
    this.getStatusOfToken();
    return this.http.post<any>(this.constants.API_URL + "nmcg/addthemeorindicator", option,this.sessionlogin.getHeadersWithCsrf()).pipe(
      catchError(this.errorHandler.handleError('get parent child list : ', [])))
  }
  getDataForAssesment(option: object):Observable<any>{
    return this.http.post<any>(this.constants.API_URL + "cwmi/stateHieAndAssmntData", option).pipe(
      catchError(this.errorHandler.handleError('get parent child list : ', [])))
  }
  getLocationListforUser(option: object):Observable<any>{
    return this.http.post<any>(this.constants.API_URL + "nmcg/parentChildMap", option).pipe(
      catchError(this.errorHandler.handleError('get parent child list : ', [])))
  }
  automationaggregate(option: object):Observable<any>{
    return this.http.post<any>(this.constants.API_URL_SHAPEFILE + "py/shpAutomation/aggregate", option).pipe(
      catchError(this.errorHandler.handleError('get parent child list : ', [])))
  }
  forecetriggerlocationlist(options: object):Observable<any>{
    return this.http.post<any>(this.constants.API_URL + "nmcg/forcetrigger/locationlist", options).pipe(
      catchError(this.errorHandler.handleError('excelupload', [])) );
  }
  triggercomputations(options: object):Observable<any>{
    this.getStatusOfToken();
    return this.http.post<any>(this.constants.API_URL + "cwmi/forcetriggercomputations", options,this.sessionlogin.getHeadersWithCsrf()).pipe(
      catchError(this.errorHandler.handleError('excelupload', [])) );
  }
  getWindowStatusData(options: object):Observable<any>{
    return this.http.post<any>(this.constants.API_URL + "nmcg/window/multiyearwindow", options).pipe(
      catchError(this.errorHandler.handleError('excelupload', [])) );
  }
  raisewindowrequest(options: object):Observable<any>{
    return this.http.post<any>(this.constants.API_URL + "nmcg/window/raiserequest", options,this.sessionlogin.getHeadersWithCsrf()).pipe(
      catchError(this.errorHandler.handleError('excelupload', [])) );
  }
  getraiserequesthistory(options: object):Observable<any>{
    return this.http.post<any>(this.constants.API_URL + "nmcg/window/raiserequesthistory", options).pipe(
      catchError(this.errorHandler.handleError('excelupload', [])) );
  }
  getrequestlist(options: object):Observable<any>{
    return this.http.post<any>(this.constants.API_URL + "nmcg/window/getrequestlist", options).pipe(
      catchError(this.errorHandler.handleError('excelupload', [])) );
  }
  acceptwindowrequest(options: object):Observable<any>{
    return this.http.post<any>(this.constants.API_URL + "nmcg/window/acceptrequest", options,this.sessionlogin.getHeadersWithCsrf()).pipe(
      catchError(this.errorHandler.handleError('excelupload', [])) );
  }
  setwindow(options: object):Observable<any>{
    return this.http.post<any>(this.constants.API_URL + "nmcg/window/setwindow", options,this.sessionlogin.getHeadersWithCsrf()).pipe(
      catchError(this.errorHandler.handleError('excelupload', [])) );
  }
  deletewindow(options: object):Observable<any>{
    return this.http.post<any>(this.constants.API_URL + "nmcg/window/deletewindow", options,this.sessionlogin.getHeadersWithCsrf()).pipe(
      catchError(this.errorHandler.handleError('excelupload', [])) );
  }
  getnotifications(options: object):Observable<any>{
    return this.http.post<any>(this.constants.API_URL + "cwmi/notification/childlog", options).pipe(
      catchError(this.errorHandler.handleError('excelupload', [])) );
  }
  profileFormSubmit(options: object):Observable<any>{
    return this.http.post<any>(this.constants.API_URL + "nmcg/profile/create", options).pipe(
      catchError(this.errorHandler.handleError('excelupload', [])) );
  }
  profileDataSubmit(options: object): Observable<any> {
    return this.http.post<any>(this.constants.API_URL + "nmcg/upload/userdetails", options).pipe(
      catchError(this.errorHandler.handleError('excelupload', [])));
  }
  getprofileData(options: object): Observable<any> {
    return this.http.post<any>(this.constants.API_URL + "nmcg/get/userdetails", options).pipe(
      catchError(this.errorHandler.handleError('excelupload', [])));
  }
  getaggregatedData(options: object): Observable<any> {
    return this.http.post<any>(this.constants.API_URL + "nmcg/aggregateData", options).pipe(
      catchError(this.errorHandler.handleError('excelupload', [])));
  }
  
  getAttendantReport(option: object):Observable<any>{
    return this.http.post<any>(this.constants.API_URL + "nmcg/DGCMeetingAttendantReport", option).pipe(
      catchError(this.errorHandler.handleError('get parent child list : ', [])))
  }

  getLoginDetails(option: object):Observable<any>{
    return this.http.post<any>(this.constants.API_URL + "nmcg/getLoginDetails", option).pipe(
      catchError(this.errorHandler.handleError('excelupload', [])))
  }

  uploadbroadcast(option: object):Observable<any>{
    return this.http.post<any>(this.constants.API_URL + "nmcg/upload/uploadBroadCastDetails", option).pipe(
      catchError(this.errorHandler.handleError('get parent child list : ', [])) )
  }

  getBroadcastDetails(option: object):Observable<any>{
    this.getStatusOfToken();
    return this.http.post<any>(this.constants.API_URL + "nmcg/getBroadCastDetails", option).pipe(
      catchError(this.errorHandler.handleError('get parent child list : ', [])) )
  }

  updateEnabledThemes(option: object):Observable<any>{
    return this.http.post<any>(this.constants.API_URL + "nmcg/updateThemeEnableStats", option).pipe(
      catchError(this.errorHandler.handleError('get parent child list : ', [])) )
  }

  getEnabledThemes(option: object):Observable<any>{
    return this.http.post<any>(this.constants.API_URL + "nmcg/fetchThemeEnableStats", option).pipe(
      catchError(this.errorHandler.handleError('get parent child list : ', [])) )
  }

  insertYearToDisplay(option: object):Observable<any>{
    return this.http.post<any>(this.constants.API_URL + "nmcg/insertYeartoDisplay", option).pipe(
      catchError(this.errorHandler.handleError('get parent child list : ', [])) )
  }

  removeYearFromDisplay(option: object):Observable<any>{
    return this.http.post<any>(this.constants.API_URL + "nmcg/disableyear", option).pipe(
      catchError(this.errorHandler.handleError('get parent child list : ', [])) )
  }

  getYearsToDisplay(option: object):Observable<any>{
    return this.http.post<any>(this.constants.API_URL + "nmcg/fetchYeartoDisplay", option).pipe(
      catchError(this.errorHandler.handleError('get parent child list : ', [])) )
  }

  getassesmentYear(){
    this.getdynamicYears();
  }

  getSortedUserList():Observable<any> {
    let api = "nmcg/sortedUserList";
    return this.http.get<any>(this.constants.API_URL + api).pipe(
        catchError(this.errorHandler.handleError('excelupload', [])));
  }

  getDGCsList(option: object):Observable<any> {
    let api = "nmcg/getDGCList/" + option;
    return this.http.get<any>(this.constants.API_URL + api).pipe(
        catchError(this.errorHandler.handleError('excelupload', [])));
  }

  getAbstractReport(option: object):Observable<any>{
    return this.http.post<any>(this.constants.API_URL + "nmcg/getabstractreport", option).pipe(
      catchError(this.errorHandler.handleError('get parent child list : ', [])) );
  }
  getDGCMeetingReport(option: object):Observable<any>{
    return this.http.post<any>(this.constants.API_URL + "nmcg/DGCReportStatus", option).pipe(
      catchError(this.errorHandler.handleError('get parent child list : ', [])) );
  }

  deleteIndicatorData(option: object):Observable<any>{
    return this.http.post<any>(this.constants.API_URL + "nmcg/deleteindicatordata", option).pipe(
      catchError(this.errorHandler.handleError('get parent child list : ', [])) );
  }

  dataforReportChart(option: object):Observable<any>{
    return this.http.post<any>(this.constants.API_URL + "nmcg/dataforreportchart", option).pipe(
      catchError(this.errorHandler.handleError('get parent child list : ', [])) );
  }

  dgcAttendanceStatus(option: object):Observable<any>{
    return this.http.post<any>(this.constants.API_URL + "nmcg/DGCAttendanceStatus", option).pipe(
      catchError(this.errorHandler.handleError('get parent child list : ', [])) );
  }

  downloadMeetingReports(option: object):Observable<any>{
    const requestOptions: Object = {
      responseType: 'blob'
    }
    return this.http.post<any>(this.constants.API_URL + "nmcg/MeetingReportsSummaryPDF", option,requestOptions).pipe(
    catchError(this.errorHandler.handleError('get parent child list : ', [])))
  }

  downloadDGCsAttendanceReports(option: object):Observable<any>{
    const requestOptions: Object = {
      responseType: 'blob'
    }
    return this.http.post<any>(this.constants.API_URL + "nmcg/DGCAttendanceStatusSheet", option,requestOptions).pipe(
    catchError(this.errorHandler.handleError('get parent child list : ', [])))
  }
  downloadMoMforYear(option: object):Observable<any>{
    const requestOptions: Object = {
      responseType: 'blob'
    }
    return this.http.post<any>(this.constants.API_URL + "nmcg/downloadMoMForAy", option,requestOptions).pipe(
    catchError(this.errorHandler.handleError('get parent child list : ', [])))
  }


}
